module.exports = __webpack_public_path__ + "static/media/LU.daa6afb9.png";